// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="life_time.LTVByMissionChart"></bfg-chart>
</div>

<installs-table rows="rows" get-players="amt.ww2.life_time.players_purchases"></installs-table>
`;
// Exports
module.exports = code;